import guards from "@/pages/guards"

const Index = (resolve) => {
  require.ensure(["./index.vue"], () => {
    resolve(require("./index.vue"))
  }, "quotations")
}

const Form = (resolve) => {
  require.ensure(["./form/form.vue"], () => {
    resolve(require("./form/form.vue"))
  }, "quotations")
}

const Show = (resolve) => {
  require.ensure(["./show/show.vue"], () => {
    resolve(require("./show/show.vue"))
  }, "quotations")
}

const ShowDif = (resolve) => {
  require.ensure(["./show/showDifRev.vue"], () => {
    resolve(require("./show/showDifRev.vue"))
  }, "quotations")
}

export default class QuotationsRouter {

    static addRoutes(appRoutes) {

      appRoutes.push({ path: "quotations", component: Index, beforeEnter: guards.onlyNonCustomers })
      appRoutes.push({ path: "quotations/form/:id", component: Form, beforeEnter: guards.onlyNonCustomers })
      appRoutes.push({ path: "quotations/show/:id", component: Show, beforeEnter: guards.onlyNonCustomers })
      appRoutes.push({ path: "quotations/showdif/:id/:rev", component: ShowDif, beforeEnter: guards.onlyNonCustomers })
    }
}
